import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  padding: 10px;\n'], ['\n  padding: 10px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 10px;\n  color: ', ';\n'], ['\n  padding: 10px;\n  color: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: absolute;\n  z-index: 50;\n  width: 100%;\n  background-color: white;\n  height: 40px;\n  display: flex;\n  justify-content: space-around;\n  padding: 10px 10px 30px 10px;\n  box-shadow: 0 16px 48px 0 rgba(33, 21, 81, 0.08);\n  border-radius: 8px;\n'], ['\n  position: absolute;\n  z-index: 50;\n  width: 100%;\n  background-color: white;\n  height: 40px;\n  display: flex;\n  justify-content: space-around;\n  padding: 10px 10px 30px 10px;\n  box-shadow: 0 16px 48px 0 rgba(33, 21, 81, 0.08);\n  border-radius: 8px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  display: \'inline-block\';\n  width: 16px;\n  height: 16px;\n  border-radius: 6px;\n  background-color: ', ';\n  box-shadow: ', ';\n'], ['\n  display: \'inline-block\';\n  width: 16px;\n  height: 16px;\n  border-radius: 6px;\n  background-color: ', ';\n  box-shadow: ', ';\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  ', ';\n  position: relative;\n'], ['\n  ', ';\n  position: relative;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  border-radius: 18px;\n  width: fit-content;\n  padding-right: 5px;\n  padding-left: 10px;\n  height: 40px;\n  background-color: ', ';\n  color: ', ';\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  font-weight: 500;\n'], ['\n  border-radius: 18px;\n  width: fit-content;\n  padding-right: 5px;\n  padding-left: 10px;\n  height: 40px;\n  background-color: ', ';\n  color: ', ';\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  font-weight: 500;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  background-color: ', ';\n  color: white;\n  padding-top: 7px;\n  padding-bottom: 7px;\n  padding-left: 12px;\n  border-radius: 14px;\n  padding-right: 12px;\n  cursor: pointer;\n'], ['\n  background-color: ', ';\n  color: white;\n  padding-top: 7px;\n  padding-bottom: 7px;\n  padding-left: 12px;\n  border-radius: 14px;\n  padding-right: 12px;\n  cursor: pointer;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  padding: 10px;\n  background-color: initial;\n  color: inherit;\n  font: inherit;\n  font-size: initial !important;\n  border: none;\n'], ['\n  padding: 10px;\n  background-color: initial;\n  color: inherit;\n  font: inherit;\n  font-size: initial !important;\n  border: none;\n']);

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from './..';
import { ContextMenuContainer, ContextMenu, ContextMenuItem } from './..';
import { styles, translations } from 'gipsy-misc';

var propTypes = {
  id: PropTypes.string,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  name: PropTypes.string,
  mode: PropTypes.string,
  style: PropTypes.object
};

var Tag = function (_Component) {
  _inherits(Tag, _Component);

  function Tag(props) {
    _classCallCheck(this, Tag);

    var _this = _possibleConstructorReturn(this, (Tag.__proto__ || Object.getPrototypeOf(Tag)).call(this, props));

    _this.onEdit = function () {
      _this.setState({
        mode: 'edit'
      });
    };

    _this.onDelete = function () {
      if (_this.props.onDelete) {
        var id = _this.state.id;

        _this.props.onDelete({ id: id });
      }
    };

    _this.onRemove = function (e) {
      if (_this.props.onRemove) {
        var _this$state = _this.state,
            id = _this$state.id,
            name = _this$state.name,
            color = _this$state.color,
            backgroundColor = _this$state.backgroundColor;

        _this.props.onRemove({ id: id, name: name, color: color, backgroundColor: backgroundColor });
        if (e) {
          e.stopPropagation();
        }
      }
    };

    _this.onCreate = function () {
      if (_this.props.onCreate) {
        var _this$state2 = _this.state,
            id = _this$state2.id,
            name = _this$state2.name,
            color = _this$state2.color,
            backgroundColor = _this$state2.backgroundColor;

        _this.props.onCreate({ id: id, name: name, color: color, backgroundColor: backgroundColor });
      }
    };

    _this.onSubmit = function () {
      if (_this.state.mode === 'edit') {
        _this.onSave();
      }
      if (_this.state.mode === 'create') {
        _this.onCreate();
      }
    };

    _this.onSave = function () {
      if (_this.props.onSave) {
        var _this$state3 = _this.state,
            id = _this$state3.id,
            name = _this$state3.name,
            color = _this$state3.color,
            backgroundColor = _this$state3.backgroundColor;

        _this.props.onSave({ id: id, name: name, color: color, backgroundColor: backgroundColor });
      }
      _this.setState({ mode: 'more' });
    };

    _this.onKeyDown = function (e) {
      if (e.keyCode === 13) {
        _this.onSubmit();
      } else if (e.keyCode === 27) {
        _this.onRemove();
      }
    };

    _this.onChangeColor = function (_ref) {
      var color = _ref.color,
          backgroundColor = _ref.backgroundColor;

      _this.setState({ color: color, backgroundColor: backgroundColor });
    };

    _this.ColorSuggestions = function () {
      var color = _this.state.color;

      var tagColors = styles.colors.tagColors;
      return React.createElement(
        ColorsContainer,
        null,
        tagColors.map(function (tagColor) {
          var selected = color === tagColor.color;
          return React.createElement(ColorPick, {
            key: tagColor.color,
            color: tagColor.color,
            onClick: function onClick() {
              return _this.onChangeColor(tagColor);
            },
            selected: selected
          });
        })
      );
    };

    _this.state = {
      id: props.id,
      name: props.name,
      color: props.color,
      backgroundColor: props.backgroundColor,
      mode: props.mode
    };

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  _createClass(Tag, [{
    key: 'handleChange',
    value: function handleChange(event) {
      this.setState({ name: event.target.value });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.input) {
        this.input.focus();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.input) {
        this.input.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          name = _state.name,
          color = _state.color,
          backgroundColor = _state.backgroundColor,
          mode = _state.mode;
      var style = this.props.style;


      return React.createElement(
        Wrap,
        { style: style },
        React.createElement(
          TagContainer,
          { color: color, backgroundColor: backgroundColor, className: 'tag-container' },
          mode === 'edit' && React.createElement(
            Fragment,
            null,
            React.createElement(Input, {
              type: 'text',
              value: name,
              onChange: this.handleChange,
              onKeyDown: this.onKeyDown,
              ref: function ref(input) {
                _this2.input = input;
              }
            }),
            React.createElement(
              Badge,
              { onClick: this.onSave, backgroundColor: color },
              translations.tag.save
            )
          ),
          mode === 'removable' && React.createElement(
            Fragment,
            null,
            React.createElement(
              TagName,
              null,
              name
            ),
            React.createElement(
              IconWrapper,
              null,
              React.createElement(Icon, { icon: 'Close', fill: color, size: 10, onClick: this.onRemove })
            )
          ),
          mode === 'more' && React.createElement(
            Fragment,
            null,
            React.createElement(
              TagName,
              null,
              name
            ),
            React.createElement(
              ContextMenuContainer,
              null,
              function (ref, onContextMenu, closeMenu, isActive) {
                return React.createElement(
                  Fragment,
                  null,
                  React.createElement(
                    IconWrapper,
                    null,
                    React.createElement(Icon, { icon: 'More', fill: color, onClick: onContextMenu })
                  ),
                  React.createElement(
                    ContextMenu,
                    { isActive: isActive, setRef: ref },
                    React.createElement(
                      ContextMenuItem,
                      { height: 20, onClick: _this2.onEdit },
                      React.createElement(
                        EditLabel,
                        null,
                        translations.tag.edit
                      )
                    ),
                    React.createElement(
                      ContextMenuItem,
                      { height: 20, onClick: _this2.onDelete },
                      React.createElement(
                        DeleteLabel,
                        null,
                        translations.tag.delete
                      )
                    )
                  )
                );
              }
            )
          ),
          mode === 'create' && React.createElement(
            Fragment,
            null,
            React.createElement(Input, {
              type: 'text',
              value: name,
              placeholder: translations.taskPanel.tags.newTag,
              onChange: this.handleChange,
              onKeyDown: this.onKeyDown,
              ref: function ref(input) {
                _this2.input = input;
              }
            }),
            React.createElement(
              IconWrapper,
              null,
              React.createElement(Icon, { icon: 'Close', fill: color, size: 10, onClick: this.onRemove })
            ),
            React.createElement(
              Badge,
              { onClick: this.onCreate, backgroundColor: color },
              translations.general.create
            )
          ),
          mode === 'preview' && React.createElement(
            TagName,
            null,
            name
          )
        ),
        (mode === 'create' || mode === 'edit') && React.createElement(this.ColorSuggestions, null)
      );
    }
  }]);

  return Tag;
}(Component);

Tag.propTypes = propTypes;


export default Tag;

var EditLabel = styled.div(_templateObject);

var DeleteLabel = styled.div(_templateObject2, styles.colors.pinkColor);

var ColorsContainer = styled.div(_templateObject3);

var ColorPick = styled.div(_templateObject4, function (props) {
  return props.color;
}, function (props) {
  return props.selected ? '0 8px 12px 0 ' + props.color : '';
});

var Wrap = styled.div(_templateObject5, function (props) {
  return props.style;
});

var TagContainer = styled.div(_templateObject6, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.color;
});

var Badge = styled.span(_templateObject7, function (props) {
  return props.backgroundColor;
});

var TagName = styled.span(_templateObject);

var IconWrapper = styled.div(_templateObject);
var Input = styled.input(_templateObject8);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/Tag/index.js
// module id = 826
// module chunks = 0